// Independent Variables (input-only)
export const PRESSURE = 0;
export const RADIUS = 1;
export const THICKNESS = 2;

// Dependent Variables (input-output)
export const FORCE = 0;
export const AREA = 1;
export const STRESS = 2;